import { TransactionsState } from "./types";

export const TRANSACTIONS_DEFAULT_STATE: TransactionsState = {
  filters: [],
  searchTerm: ""
};
